import { AxiosResponse } from "axios";
import { ScorecardMeta } from "../../Model/Dto/Scorecard/ScorecardMeta";
import { axiosInstance } from "../AxiosInterceptor";
import * as ApiUrls from "./ApiUrl.MyBEE123Homepage";

export const MyBEE123HomepageService = {
    getAllUserScorecards: (): Promise<AxiosResponse<ScorecardMeta.ScorecardMetaViewModel[]>> => axiosInstance.get(ApiUrls.getAllUserScorecards),
    getBEEUserScorecards: (): Promise<AxiosResponse<ScorecardMeta.ScorecardMetaViewModel[]>> => axiosInstance.get(ApiUrls.getBEEUserScorecards),
    getEEUserScorecards: (): Promise<AxiosResponse<ScorecardMeta.ScorecardMetaViewModel[]>> => axiosInstance.get(ApiUrls.getEEUserScorecards),
}